import {FC} from "react";
import {useOutletContext} from "react-router-dom";
import { UnityVisitControlTabContent } from "./content";
import { Unity } from "../../../../domain/unity";

export const UnityVisitControlTab: FC<any> = () => {
    const unity = useOutletContext<Unity>();
    return <UnityVisitControlTabContent unity={unity}/>;
};
